import PropTypes from "prop-types";

const RATIOS = {
  portrait: "aspect-[4/5]",
  square: "aspect-square",
  wide: "aspect-[16/9]",
  card: "aspect-[4/3]",
  tall: "aspect-[3/4]",
};

export default function BrandPhoto({
  src,
  alt,
  ratio = "portrait",
  caption,
  className = "",
  testId = "brand-photo",
}) {
  const ratioCls = RATIOS[ratio] || RATIOS.portrait;
  return (
    <figure
      data-testid={testId}
      className={`relative overflow-hidden rounded-[14px] ${ratioCls} ${className}`}
      style={{ border: "1px solid var(--wt-border)", backgroundColor: "#0c0c0c" }}
    >
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover"
      />
      {caption && (
        <figcaption
          className="absolute bottom-0 left-0 right-0 px-3 py-2 text-[11px] tracking-[0.12em] uppercase"
          style={{
            background:
              "linear-gradient(180deg, rgba(2,44,34,0) 0%, rgba(2,44,34,0.7) 100%)",
            color: "rgba(250,247,240,0.95)",
          }}
        >
          {caption}
        </figcaption>
      )}
    </figure>
  );
}

BrandPhoto.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  ratio: PropTypes.oneOf(["portrait", "square", "wide", "card", "tall"]),
  caption: PropTypes.string,
  className: PropTypes.string,
  testId: PropTypes.string,
};
